export const adjustVideoHeights = () => {
    const videoWrappers = document.querySelectorAll('.texts-and-links-wrapper.teaser-wrapper .video-wrapper') as NodeListOf<HTMLElement>;

    videoWrappers.forEach((videoWrapper) => {
        if (window.innerWidth >= 600) {
            videoWrapper.style.removeProperty('height');
            return; 
        }

        const parent = videoWrapper.parentElement;
        if (!parent) return;

        const teaserTextWrapper = parent.querySelector('.teaser-text-wrapper') as HTMLElement | null;

        if (teaserTextWrapper && teaserTextWrapper.innerHTML.trim() !== '') {
            const textHeight = teaserTextWrapper.offsetHeight; 
            videoWrapper.style.minHeight = `${textHeight * 3}px`;
        }
    });
}

window.addEventListener('resize', adjustVideoHeights);